<template>
  <div
    class="sidebar"
    :class="{'sidebar_hidden' : !showSidebar}"
  />
</template>
<script>
export default {
  name: 'RightSideBar',
  props: {
    showSidebar: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  .sidebar {
    flex: 1;
    background-color: #F4F8FA;
    border-left: 2px solid #E0E6EE;
    transition: flex 0.6s ease;
    @media(max-width: 992px) {
      flex: 0;
      width: 0;
      overflow: hidden;
    }
  }
  .sidebar_hidden {
    flex: 0;
  }

</style>
